module.exports = __webpack_public_path__ + "img/1.06b92f82.png";